import { useState, useCallback, useEffect } from "react";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import Section from "core/components/Section";
import { _t } from "core/language";
import { useRecipe } from "./../hooks/recipe";
import { useMyIngredient } from "./../hooks/myIngredient";
import AddIngredientSwiperButton from "./../components/AddIngredientSwiperButton";
import MyIngredientList from "./../components/MyIngredients/List";
import MyIngredientItemLoading from "./../components/MyIngredients/MyIngredientItemLoading";
import IngredientList from "./../components/Ingredients/List";
import type { TIngredient } from "./../store/types";

const MyIngredientTab = ({handleSetShowListIngredient}: any) => {
  useScrollToTop();
  const { ingredients: ingredientSelected } = useRecipe();

  const {
    loading,
    ingredients: myIngredients,
    addToMyIngredients,
    onRemoveMyIngredients,
    sort,
    setSort,
    reload,
  } = useMyIngredient();
  const [isShowListIngredient, setIsShowListIngredient] =
    useState<boolean>(false);

  const onSelectIngradient = useCallback(
    (items: TIngredient[]) => {
      setIsShowListIngredient(false);
      addToMyIngredients(items);
    },
    [setIsShowListIngredient, addToMyIngredients]
  );

  useEffect(() => {
    reload?.()
  }, [])

  const noIngredients = !myIngredients?.length;

  return (
    <div>
      {isShowListIngredient ? (
        <div>
          <Section className="pb-3.5 pt-[30px]">
            <IngredientList
              myIngredients={myIngredients}
              onSelectIngradient={onSelectIngradient}
            />
          </Section>
        </div>
      ) : noIngredients && loading ? (
        <div>
          <Section className="py-3.5">
            <div className="grid grid-cols-2 gap-5">
              {Array.from(Array(10).keys()).map((e: number) => (
                <MyIngredientItemLoading key={e} />
              ))}
            </div>
          </Section>
        </div>
      ) : noIngredients ? (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-full text-center">
            <label className="block mb-[20px] whitespace-nowrap text-[15px] font-medium">
              {_t("ingredient.nodata")}
            </label>
            <div className="flex justify-center">
              <AddIngredientSwiperButton
                className="w-full text-[15px] font-medium h-[50px] min-w-[216px]"
                onAddByList={() => {
                  setIsShowListIngredient(true);
                  handleSetShowListIngredient(true);
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <Section className="py-[30px]">
            <MyIngredientList
              ingredients={myIngredients}
              ingredientSelected={ingredientSelected}
              onAddByList={() => {
                setIsShowListIngredient(true);
                handleSetShowListIngredient(true);
              }}
              sort={sort}
              setSort={setSort}
              onRemoveMyIngredients={onRemoveMyIngredients}
            />
          </Section>
        </div>
      )}
    </div>
  );
};

export default MyIngredientTab;
